// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__3mwF1","img":"Card_img__2VRpD","cardroot":"Card_cardroot__1NyaK","darkcardroot":"Card_darkcardroot__-_wKJ"};